import React, { Component } from 'react';
import PropTypes from 'prop-types'

import SignInForm from '../SignInForm'
import { PootsyTitle } from "../DesignFunctions";


export default class BookingFlowSignIn extends Component {
	render() {

		let { t } = this.context

		return (
			<div className="booking-flow-sign-in">
				<div className="left">
					<PootsyTitle title={t('signin_header')}/>
					<div className="signin-prompt">
						{t('signin_prompt')}
					</div>
					<div onClick={this.props.onSignUpClick} className="login-link">{t('booking_flow_sign_up')}</div>
				</div>
				<div className="right">
					<SignInForm />
				</div>
			</div>
		)
	}
}

BookingFlowSignIn.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowSignIn.js